import { render, staticRenderFns } from "./ReactivePayment.vue?vue&type=template&id=4b1469ac&"
import script from "./ReactivePayment.vue?vue&type=script&lang=js&"
export * from "./ReactivePayment.vue?vue&type=script&lang=js&"
import style0 from "./ReactivePayment.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports